import { posthog } from './posthog'

// Ring buffer of the latest API errors. Powers two support flows:
// - the Sentry "Báo lỗi" report attaches these req_ids so an admin can trace
//   the exact failed calls in Loki without asking the user anything;
// - each error is also captured as a PostHog `api_error` event, linking a
//   req_id quoted from an error toast to the user's session replay.
export interface RecentApiError {
    requestId?: string
    status: number
    code: string
    method: string
    path: string
    message: string
    at: string
}

export type ApiErrorInput = Omit<RecentApiError, 'at'>

const MAX_RECENT_ERRORS = 10

const buffer: RecentApiError[] = []

export function recordApiError(input: ApiErrorInput): void {
    buffer.push({ ...input, at: new Date().toISOString() })
    if (buffer.length > MAX_RECENT_ERRORS) {
        buffer.shift()
    }
}

export function getRecentApiErrors(): RecentApiError[] {
    return [...buffer]
}

export function clearRecentApiErrors(): void {
    buffer.length = 0
}

// Record + emit telemetry for one failed API call. The message stays local
// (it can contain user data); PostHog only gets routing metadata.
export function trackApiError(input: ApiErrorInput): void {
    try {
        recordApiError(input)
    } catch {
        // Telemetry must never break the error path itself.
    }
    try {
        if (!posthog.__loaded) return
        posthog.capture('api_error', {
            req_id: input.requestId,
            status: input.status,
            code: input.code,
            method: input.method,
            path: input.path,
            route: window.location.pathname,
        })
    } catch {
        // Telemetry must never break the error path itself.
    }
}
